<template>
  <div class="prematch-mini-wrapper">
    <div class="match-header">
      <h1 class="title_league" @click="setSearch">{{ league }}</h1>
      <div class="time">
        <ClockIcon />
        <span>{{ startTime }}</span>
      </div>
      <div class="header-nav">
        <div class="tag tag-select">
          <!-- <select v-model="companyId">
            <option v-for="(item, index) in companies" :value="item._id" :key="index">{{ item.name }}</option>
          </select> -->
        </div>
        <div class="favorite">
          <!-- A-9: гейтинг по правам (prematch: FAVORITE / DATA) -->
          <Lock permission="PREMATCH_FAVORITE">
            <FavoriteStar :active="isFavorite" @click="$emit('favorite')" />
          </Lock>
          <Lock permission="PREMATCH_DATA">
            <span class="icon match-expand view" @click="$emit('view')">
              <TriangleIcon
                width="16"
                height="12"
                :rotate="mini ? 'up' : 'down'"
              />
            </span>
          </Lock>
        </div>
      </div>
    </div>
    <div class="match-body">
      <div class="header">
        <div class="team">
          <h2>{{ home.name }}</h2>
          <WinCoef :value="home.winCoef" />
        </div>
        <div class="stat">
          <LiveStatistics
            v-show="!mini"
            :stat-list="statList"
            :home="home"
            :away="away"
            is-pre
          />
          <div v-if="companyData.indexes" class="info">
            <div
              v-for="(row, rowIndex) in companyData.indexes"
              :key="`row-${rowIndex}`"
              style="display: flex; align-items: center"
            >
              <div class="item">
                <h3>{{ row.title }}</h3>
                <div class="part-indexes">
                  <div
                    v-for="(partIndex, index) in row.partIndexes"
                    :key="index"
                    class="part-index"
                    :class="partIndexClass(partIndex)"
                  >
                    {{ partIndex.key }}
                  </div>
                </div>
                <div class="win-wrapper">
                  <div
                    v-for="(partIndex, index) in row.partIndexes"
                    :key="index"
                    class="win-box"
                  >
                    <ArrowIcon :class="getArrowIconClass(partIndex.status)" />
                    <div class="win-been" :class="getWinBeenClass(partIndex)">
                      {{ partIndex.key }} [{{ partIndex.diff }}]
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="rowIndex == 0" :key="'block'" class="block"></div>
            </div>
          </div>
        </div>
        <div class="team">
          <h2>{{ away.name }}</h2>
          <WinCoef :value="away.winCoef" />
        </div>
      </div>
      <div v-show="!mini" class="tables">
        <div
          v-for="group in companyData.odds"
          :key="group.id"
          class="odds-group"
          style="
            display: flex;
            width: 100%;
            flex-direction: column;
            align-items: center;
          "
        >
          <span class="table_title">{{ group.title }}</span>

          <div class="wrap">
            <div class="live_first">
              <span
                class="text-danger"
                style="
                  line-height: 19.84px;
                  color: var(--danger-color);
                  margin-bottom: 16px;
                "
                >Live</span
              >
              <span>First</span>
            </div>

            <div class="big-table first">
              <div class="top">HT</div>
              <div class="bottom">
                <div v-for="(pair, i) in group.ht" :key="i" class="item">
                  <TradeDynamicCell
                    v-if="pair.live"
                    :value="pair.live.value"
                    :rate-value="getRateValue(pair.live)"
                  />
                  <span>{{ formatValue(pair.first?.value) }}</span>
                </div>
              </div>
            </div>

            <div class="big-table last">
              <div class="top">FT</div>
              <div class="bottom">
                <div v-for="(pair, i) in group.ft" :key="i" class="item">
                  <TradeDynamicCell
                    v-if="pair.live"
                    :value="pair.live.value"
                    :rate-value="getRateValue(pair.live)"
                  />
                  <span>{{ formatValue(pair.first?.value) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MatchUtil } from "@/store/utils";
import TriangleIcon from "./common/icons/Triangle.vue";
import ArrowIcon from "./common/icons/Arrow.vue";
import TradeDynamicCell from "./common/TradeDynamicCell.vue";
import FavoriteStar from "./common/FavoriteStar.vue";
import Lock from "./common/Lock.vue";
import ClockIcon from "./common/icons/Clock.vue";
import WinCoef from "./common/WinCoef.vue";
import LiveStatistics from "./common/LiveStatistics.vue";

const { HANDICAP_ORIGINAL_KEYS, HANDICAP_TITLES, MatchList } = MatchUtil;
const { MATCH_FILTER_KEYS } = MatchList;
const CATEGORY = "prematch";

const PREMATCH_SIGNAL_KEYS = {
  MOVE: "MOVE",
  FIXED: "FIXED",
};
const PREMATCH_SIGNAL_TYPES = {
  [PREMATCH_SIGNAL_KEYS.MOVE]: "Move",
  [PREMATCH_SIGNAL_KEYS.FIXED]: "Fixed",
};

const PREMATCH_SIGNAL_DIFF_KEYS = {
  SUCCESS: "success",
  FAILURE: "failure",
  NO_DIFF: "no_diff",
};

const PREMATCH_SIGNAL_DIFF_CLASS = {
  [PREMATCH_SIGNAL_DIFF_KEYS.SUCCESS]: "has-background-success",
  [PREMATCH_SIGNAL_DIFF_KEYS.FAILURE]: "has-background-danger",
  [PREMATCH_SIGNAL_DIFF_KEYS.NO_DIFF]: "",
};

const getPrematchDiffKey = (diff) => {
  switch (diff) {
    case true:
      return PREMATCH_SIGNAL_DIFF_KEYS.SUCCESS;
    case false:
      return PREMATCH_SIGNAL_DIFF_KEYS.FAILURE;
    default:
      return PREMATCH_SIGNAL_DIFF_KEYS.NO_DIFF;
  }
};

export default {
  name: "PrematchMatch",
  components: {
    TriangleIcon,
    Lock,
    TradeDynamicCell,
    FavoriteStar,
    ArrowIcon,
    ClockIcon,
    WinCoef,
    LiveStatistics,
  },
  props: {
    _id: Number,
    away: Object,
    home: Object,
    data: Array,
    fixed: Array,
    league: String,
    move: Array,
    startTime: String,
    start: Number,
    time: Object,
    mini: Boolean,
    isFavorite: Boolean,
    dataCompanies: Object,
    // CSS Classes
  },
  data() {
    return {
      companyId: 8,
      statList: [
        { title: "PPM", key: "ppm" },
        { title: "Scored", key: "goal" },
        { title: "Conceded", key: "loss" },
        { title: "Corners Avg.", key: "corner" },
      ],
    };
  },
  computed: {
    state() {
      return this.$store.state[CATEGORY];
    },

    companies() {
      return [{ _id: 1 }];
    },
    companyDataMap() {
      return [...this.data]
        .reverse()
        .reduce((acc, data) => ({ ...acc, [data.companyId]: data }), {});
    },

    companySignalMap() {
      const signalObject = {
        [PREMATCH_SIGNAL_KEYS.MOVE]: this.move,
        [PREMATCH_SIGNAL_KEYS.FIXED]: this.fixed,
      };

      return Object.keys(signalObject).reduce(
        (result, key) => ({
          ...result,
          [key]: signalObject[key].reduce((acc, data) => {
            if (!acc[data.companyId]) {
              acc[data.companyId] = {};
            }

            const typeKey = HANDICAP_ORIGINAL_KEYS[data.type];
            if (!acc[data.companyId][typeKey]) {
              acc[data.companyId][typeKey] = {};
            }

            if (!acc[data.companyId][typeKey][data.part]) {
              acc[data.companyId][typeKey][data.part] = {
                [PREMATCH_SIGNAL_DIFF_KEYS.SUCCESS]: 0,
                [PREMATCH_SIGNAL_DIFF_KEYS.FAILURE]: 0,
                [PREMATCH_SIGNAL_DIFF_KEYS.NO_DIFF]: 0,
              };
            }

            const diffKey = getPrematchDiffKey(data.diff);
            acc[data.companyId][typeKey][data.part][diffKey] += 1;

            return acc;
          }, {}),
        }),
        {},
      );
    },

    companyData() {
      return this.dataCompanies[this.companyId];
    },

    companySignals() {
      return Object.keys(this.companySignalMap).reduce(
        (acc, key) => ({
          ...acc,
          [key]: this.companySignalMap[key][this.companyId],
        }),
        {},
      );
    },

    companyIdFilter: {
      get() {
        const { value } = this.state.filters.find(
          (filter) =>
            typeof filter === "object" &&
            filter.type === MATCH_FILTER_KEYS.COMPANY,
        );
        return value;
      },
    },

    matchSignals() {
      if (!this.companyData) return false;

      const result = Object.keys(this.companySignals).reduce((acc, key) => {
        const dataTypes = this.companySignals[key];
        if (!dataTypes) return acc;

        const data = {
          title: PREMATCH_SIGNAL_TYPES[key],
          signalTypes: Object.keys(dataTypes).map((type) => {
            const dataParts = dataTypes[type];
            return {
              title: HANDICAP_TITLES[type],
              parts: Object.keys(dataParts).map((part) => {
                const dataCounters = dataParts[part];
                return {
                  title: part,
                  counters: Object.keys(dataCounters)
                    .filter((key) => dataCounters[key] > 0)
                    .map((key) => ({
                      count: dataCounters[key],
                      $class: PREMATCH_SIGNAL_DIFF_CLASS[key],
                    })),
                };
              }),
            };
          }),
        };

        return acc.concat(data);
      }, []);

      return result;
    },

    $countdownClass() {
      // TODO: create constants
      let result = "";
      const left = (this.start - Date.now()) / 1000 / 60;
      if (left >= 0 && left < 10) result = "has-text-danger";
      if (left >= 10 && left <= 15) result = "has-text-warning";
      return result;
    },
  },
  watch: {
    companyData() {
      if (this.companyData && this.companyData.companyId && !this.companyId) {
        this.companyId = +this.companyData.companyId;
      }
    },
    companyIdFilter() {
      this.selectCompany();
    },
  },

  mounted() {
    if (this.companyId === null && this.companies.length) {
      this.selectCompany();
    }
  },
  methods: {
    formatValue(val) {
      return Number.isNaN(val) || val == null ? "-" : val;
    },

    setSearch() {
      this.$store.commit("SET_SEARCH_TEXT", this.league);
    },

    selectCompany() {
      const companyId = this.companyIdFilter;
      const firstCompany = this.companies[0];
      const filterCompany = this.companies.find(({ _id }) => _id === companyId);
      this.companyId = (filterCompany || firstCompany)._id;
    },

    getRateValue({ type, diff }) {
      if (diff === null || diff === undefined) return 0;

      const isTotal = type === "total";
      return isTotal === diff ? 1 : -1;
    },
    partIndexClass({ value, diff, key }) {
      switch (value) {
        case true:
          return Math.abs(diff) > 0.25
            ? "success-background"
            : "success-background-low";
        case false:
          return Math.abs(diff) > 0.25
            ? "danger-background"
            : "danger-background-low";
        default:
          return key === "HT" ? "part-index-start" : "part-index-end";
      }
    },
    getArrowIconClass(value) {
      switch (value) {
        case "up":
          return "arrow-up";
        case "down":
          return "arrow-down";
        default:
          return "arrow-hiden";
      }
    },
    getWinBeenClass({ status, diff }) {
      switch (status) {
        case "up":
          return Math.abs(diff) > 0.25
            ? "success-background"
            : "success-background-low";
        case "down":
          return Math.abs(diff) > 0.25
            ? "danger-background"
            : "danger-background-low";
        default:
          return "been-hiden";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.stat {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}

.prematch-mini-wrapper {
  margin-bottom: 28px;

  .match-header {
    width: 100%;
    display: flex;
    border-radius: 26px 26px 0 0;
    background-color: var(--league-body-color);
    border-bottom: 1px solid var(--match-border-color);
    padding: 20px 40px 20px 40px;

    .title_league {
      font-size: 18px;
      font-weight: 700;
      line-height: 22.54px;
      color: var(--font-color);
      transition: all 0.3s;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-top: 4px;
      text-decoration: underline;
      &:hover {
        color: var(--brand-color);
      }
    }

    .time {
      display: flex;
      gap: 6px;
      align-items: center;
      padding: 10px 20px 10px 20px;
      background-color: var(--shots-body-color);
      border-radius: 26px;
      flex: none;

      span {
        font-weight: 500;
        font-size: 18px;
        line-height: 22.34px;
        letter-spacing: 0.02em;
      }
    }

    .header-nav {
      display: flex;
      justify-content: end;
      align-items: center;
      gap: 20px;
      width: 100%;

      .favorite {
        display: flex;
        gap: 20px;
        align-items: center;
      }
    }

    .view {
      cursor: pointer;
    }

    .view path {
      fill: var(--font-color);
      transition: fill 0.3s;
    }
  }

  .match-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: var(--league-body-color);
    border-radius: 0 0 26px 26px;
    width: 100%;

    .header {
      padding: 20px 40px 20px 40px;
      display: flex;
      align-items: center;
      background-color: var(--league-body-color);
      border-radius: 0 0 26px 26px;
      width: 100%;
      justify-content: space-between;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
    }

    .header .team:last-child {
      align-items: end;
    }

    .header .team:first-child {
      align-items: start;
    }

    .team {
      display: flex;
      flex-direction: column;
      gap: 10px;

      h2 {
        line-height: 19.86px;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0.02em;
        color: var(--font-colorF);
      }

      span {
        font-weight: 400;
        font-size: 16px;
        line-height: 19.84px;
        letter-spacing: 0.02em;
      }
    }

    .block {
      background-color: var(--match-border-color);
      height: 60px;
      width: 1px;
      margin: 0 50px 0 50px;
    }

    .info {
      display: flex;
      align-items: center;
      padding-top: 10px;
      // gap: 50px;

      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;

        h3 {
          color: var(--font-color);
          font-weight: 400;
          font-size: 16px;
          line-height: 19.84px;
          letter-spacing: 0.02em;
        }

        .part-indexes {
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 26px;
          overflow: hidden;
          font-weight: 500;
          line-height: 19.86px;
          letter-spacing: 0.02em;

          div {
            padding: 8px 30px 8px 30px;
            border-right: 1px solid #c5c5c5;
          }
        }
      }
    }

    .tables {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px;
      border-top: 1px solid var(--match-border-color);
      width: 100%;

      .table_title {
        margin-left: 9%;
        font-weight: 400;
        font-size: 16px;
        line-height: 29.84px;
        letter-spacing: 0.02em;
        text-align: center;
      }

      .block {
        margin: 0 80px 0 80px;
        height: 80px;
        width: 1px;
        border-radius: 10px;
        background-color: #c5c5c5;
      }

      .start {
        display: flex;
        flex-direction: column;
      }

      .wrap {
        display: flex;
        width: 100%;
        align-items: end;
        justify-content: center;
        gap: 6px;

        .live_first {
          display: flex;
          flex-direction: column;
          font-size: 16px;
          font-weight: 400;
          margin-right: 20px;
          padding-bottom: 10px;
        }
      }

      .top-tables {
        display: flex;
        align-items: center;
        gap: 6px;

        .small-table {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background-color: var(--shots-body-color);
          border-radius: 16px;
          width: 172px;

          .top {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 3px;
            padding: 10px;
            font-weight: 400;
            font-size: 16px;
            line-height: 19.84px;
            letter-spacing: 0.02em;
            color: var(--font-color);

            span {
              color: #b3b3b3;
            }
          }

          .bottom {
            width: 100%;
            border-top: 1px solid #cbcbcb;
            text-align: center;
            padding-top: 6px;
            padding-bottom: 6px;

            span {
              font-weight: 400;
              font-size: 12px;
              line-height: 14.88px;
              letter-spacing: 0.02em;
              opacity: 0.5;
              color: var(--font-color);
            }
          }
        }
      }

      .big-table {
        display: flex;
        flex-direction: column;
        background-color: var(--shots-body-color);
        width: 100%;
        max-width: 210px;
        margin-top: 6px;
        border-radius: 16px;

        .top {
          width: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 3px;
          padding: 10px;
          font-weight: 400;
          font-size: 16px;
          line-height: 19.84px;
          letter-spacing: 0.02em;
          color: var(--font-color);

          span {
            color: #b3b3b3;
          }
        }

        .bottom {
          width: 100%;
          display: flex;
          align-items: center;

          .item {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            span {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              border-top: 1px solid #cbcbcb;
              border-right: 1px solid #cbcbcb;
              color: var(--font-color);
              padding-bottom: 6px;
              padding-top: 6px;
            }

            &:last-child {
              span {
                border-right: none;
              }
            }
          }
        }
      }
    }
  }

  .tag {
    cursor: pointer;
    user-select: none;
    padding: 8px 16px 8px 16px;
    border: 1px solid var(--font-color);
    background-color: transparent;
    border-radius: 100px;
    color: var(--font-color);
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 400;

    span {
      color: #b3b3b3;
      font-weight: 700;
      line-height: 15.02px;
      padding-left: 9px;
    }
  }

  .tag-select {
    display: none;

    select {
      cursor: pointer;
      user-select: none;
      outline: none;
      border: none;
      background-color: transparent;
      color: var(--font-color);
    }
  }
}

.win-wrapper {
  display: flex;
  align-items: center;
  gap: 3px;
  height: 18px;

  .win-box {
    display: flex;
    gap: 4px;
    align-items: center;
    width: 70px;

    .arrow-up {
      fill: var(--success-color);
    }

    .arrow-down {
      fill: var(--danger-color);
      transform: rotate(180deg);
    }

    .arrow-hiden {
      display: none;
    }

    .win-been {
      padding: 3px 6px;
      border-radius: 10px;
      font-size: 10px;
      line-height: 12.4px;

      &.been-hiden {
        display: none;
      }
    }
  }
}

.match-expand {
  // см. HeaderMatch: добираем бокс под звезду, чтобы замки совпали
  padding: 3px 5px;
  fill: var(--font-color);
}

.part-index {
  background-color: #fff;
}

.part-index-start {
  color: var(--success-color);
}

.part-index-end {
  color: var(--danger-color);
}

.success-background {
  background-color: var(--success-color);
  color: white;
}

.danger-background {
  background-color: var(--danger-color);
  color: white;
}

.success-background-low {
  background-color: var(--success-background-opacity-medium);
  color: white;
}

.danger-background-low {
  background-color: var(--danger-background-opacity-medium);
  color: white;
}

@media screen and (max-width: 1024px) {
  .prematch-mini-wrapper .match-header {
    padding: 20px;
  }

  .prematch-mini-wrapper .match-body {
    .header {
      padding: 20px !important;
      gap: 34px;

      .block {
        margin: 0 40px 0 40px;
      }
    }

    .tables {
      flex-direction: column;
      gap: 40px;
    }
  }
}

@media screen and (max-width: 767px) {
  .stat {
    order: 3;
    grid-column: span 4;
    margin-top: -50px;
  }

  .prematch-mini-wrapper .match-header {
    padding: 15px;

    .title_league {
      grid-column: span 3;
      height: max-content;
      flex: none;
      font-size: 16px;
      max-width: 203px;
    }

    .time {
      width: max-content;

      svg {
        width: 14px;
        height: 14px;
      }

      span {
        font-size: 14px;
      }
    }

    .header-nav {
      grid-column: span 3;
      align-items: end;
      flex-direction: column;
    }
  }

  .prematch-mini-wrapper .match-body .header {
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;

    .block {
      margin: 0 14px 0 14px !important;
    }

    .info {
      order: 3;
      grid-column: span 4;
      justify-content: center;
    }

    .team {
      grid-column: span 2;
    }
  }

  .prematch-mini-wrapper .tables .wrap .live_first {
    order: 2;
    margin-left: 5px;
    margin-right: 5px !important;
  }

  .prematch-mini-wrapper .tables .wrap .first {
    order: 1;
  }

  .prematch-mini-wrapper .tables .wrap .last {
    order: 3;
  }

  .prematch-mini-wrapper .tables .table_title {
    margin-left: 0 !important;
  }

  .prematch-mini-wrapper .match-body .team {
    h2 {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      max-width: 120px;
    }
  }
}

@media screen and (max-width: 567px) {
  .prematch-mini-wrapper {
    .match-header {
      display: grid;
      grid-template-columns: 1fr 3fr 1fr;
      padding: 10px 15px 10px 10px;

      .title_league {
        grid-column: 2;
        grid-row: 1;
      }

      .time {
        grid-column: 1;
        grid-row: 1;
        padding: 3px 5px;
        margin-right: 5px;
      }

      .header-nav {
        grid-column: 3;
        grid-row: 1;
        align-self: center;
      }
    }

    .match-body {
      .tables {
        gap: 20px;
        padding: 10px;

        .wrap {
          gap: 0;

          .big-table {
            .top {
              font-size: 14px;
            }

            .bottom .item span {
              font-size: 12px;
              min-width: auto !important;
            }
          }

          .wrap .live_first {
            padding-bottom: 0 !important;

            span {
              font-size: 12px;
            }

            span {
              margin-bottom: 8px !important;
            }
          }
        }
      }

      .header {
        padding: 10px !important;

        .block {
          margin: 0 4px 0 4px !important;
        }

        .part-indexes {
          div {
            padding: 8px 20px 8px 20px !important;
          }
        }
      }
    }
  }
}

// @media screen and (max-width: 374px) {
//   .prematch-mini-wrapper .match-header {
//     .title_league {
//       max-width: 148px !important;
//     }
//   }
// }
</style>
